import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {SubCategoriesComponent} from './sub-categories.component';
import {AddSubCategoryComponent} from './add-sub-category/add-sub-category.component';

const routes: Routes = [
  {
    path: 'sub-categories',
    component: SubCategoriesComponent,
    data: {animation: 'subCategories'}
  },
  {
    path: 'add-sub-category/add',
    component: AddSubCategoryComponent,
    data: {animation: 'AddSubcategory/add'}
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SubCategoriesRoutingModule { }
